import styled, { css } from 'styled-components';
import { QuestionAnswerRenderer } from '@higo/common/src/features/FilledSurvey/ComponentRenderers/QuestionAnswerRenderer';
import { QuestionType } from '@higo/api';
import { SurveyRenderer } from '@higo/common/src/features/FilledSurvey/SurveyRenderer';
import { FC, memo } from 'react';
import { AnsweredQuestionRendererProps } from '@higo/common/src/features/FilledSurvey/ComponentRenderers/AnsweredQuestionRendererProps';
import { useRenderableSelectedAnswers } from '@higo/common/src/features/FilledSurvey/ComponentRenderers/useRenderableAnswers';

const Container = styled('span')(
  () => css`
    margin-left: 0.25rem;
  `,
);

const QuestionLabel = styled('span')(
  () => css`
    margin-right: 0.25rem;
  `,
);

/**
 * Open questions doesn't have child questions
 */
export const AnsweredQuestionParenthesisRenderer: FC<AnsweredQuestionRendererProps> =
  memo(({ answeredQuestion, level, ...rest }) => {
    const renderableSelectedAnswers = useRenderableSelectedAnswers(
      answeredQuestion.selectedAnswers,
      rest?.options?.isQuestionAnswerOptionRenderable,
    );

    return (
      <Container>
        (
        <QuestionLabel>
          {answeredQuestion.questionUserFriendlyLabel ??
            `${answeredQuestion.question}`}
        </QuestionLabel>
        <span>
          {QuestionType.OPEN === answeredQuestion.questionType ? (
            <span>
              <QuestionAnswerRenderer
                answered={answeredQuestion.answered}
                answer={answeredQuestion.answer}
                type={answeredQuestion.openAnswerType}
                questionType={answeredQuestion.questionType}
              />
            </span>
          ) : (
            renderableSelectedAnswers.map((answer, i, arr) => (
              <span key={answer.code}>
                <QuestionAnswerRenderer
                  answer={answer}
                  questionType={
                    answeredQuestion.questionType as
                      | QuestionType.SINGLE_CLOSED
                      | QuestionType.MULTIPLE_CLOSED
                  } // don't want to add another check
                />
                <SurveyRenderer
                  answeredQuestionsList={answer.childQuestions}
                  level={level + 1}
                  {...rest}
                />
                {i < arr.length - 1 && `; `}
              </span>
            ))
          )}
        </span>
        )
      </Container>
    );
  });
